import { render, staticRenderFns } from "./attach-management.vue?vue&type=template&id=10fd8690&scoped=true&"
import script from "./attach-management.vue?vue&type=script&lang=js&"
export * from "./attach-management.vue?vue&type=script&lang=js&"
import style0 from "./attach-management.vue?vue&type=style&index=0&id=10fd8690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd8690",
  null
  
)

export default component.exports